import AlphabetContainer from 'components/Alphabet/AlphabetContainer'
import AlphabetPresentation from 'components/Alphabet/AlphabetPresentation'
import AlphabetData from 'components/Alphabet/AlphabetData'

export default {
  Container: AlphabetContainer,
  Presentation: AlphabetPresentation,
  Data: AlphabetData,
}
